const axios = require('axios');

var getTopHopsByNganhId = (id) => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}${process.env.VUE_APP_TOHOPBYNGANHID}/${id}`, {
    }).then( response => {
        return response
    }).catch(error => {
       return error.message
    });
};

var getToHops = () => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}`)
        .then( response => {
            return response
        }).catch(error => {
            return error.message
        });
};

var getToHop = (id) => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}/${id}`)
        .then( response => {
            return response
        }).catch(error => {
            return error.message
        });
};

var createToHop = (payload) => {
    return axios.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}`, {
        maToHop: payload.maToHop,
        tenToHop: payload.tenToHop
    }).then(response => {
        return response;
    }).catch(error => {
        return error.response;
    })
};

var updateToHop = (payload) => {
    return axios.put(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}/${payload.id}`, {
        maToHop: payload.maToHop,
        tenMonHoc: payload.tenMonHoc
    }).then(response => {
        return response;
    }).catch(error => {
        return error.response;
    })
};

var deleteToHop = (id) => {
    return axios.delete(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}/${id}`)
    .then(response => {
        return response;
    }).catch(error => {
        return error.response;
    });
}

var getToHopById = (id) => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TOHOP}/${id}`)
    .then(response => {
        return response;
    }).catch(error => {
        return error.response;
    });
}

export const ToHopService = {
    getTopHopsByNganhId, getToHops, getToHop, createToHop, updateToHop, deleteToHop, getToHopById
}